import styled from 'styled-components';

export const RadioButtonContainer = styled.div``;

export const RadioButtonContent = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 4px;
`;

export const RadioButtonStyled = styled.div<{ items: number }>`
  width: calc(100% / ${props => props.items});
  height: 40px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ad9552;
  padding: 0 8px;
  display: flex;
`;

export const RadioButtonIndicator = styled.div<{ checked: boolean }>`
  width: 20px;
  height: 20px;
  border: 2px solid ${props => (props.checked ? '#5f522d' : '#d9d9d9')};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RadioButtonIndicatorInner = styled.div`
  width: 10px;
  height: 10px;
  background-color: #5f522d;
  border-radius: 50%;
`;

export const HelperText = styled.div`
  margin-top: 8px;
`;
